import BreadcrumbBar from '@interflora/ui-components/build/components/BreadcrumbBar/BreadcrumbBar'
import MainContent from '@interflora/ui-components/build/components/MainContent/MainContent'
import OrderHistory from 'components/OrderHistory/OrderHistory'
import { useRouter } from 'next/router'
import { getOutlineRenderGraph, OutlineRenderGraph } from 'utils/getRenderGraph'
import Page from '../../components/Page/Page'
import { renderComponents } from '../../utils/components'

const Index = (renderGraph: OutlineRenderGraph) => {
  const router = useRouter()
  const { page } = renderGraph
  return (
    <Page renderGraph={renderGraph} onIsSignedOut={() => router.replace('/sign-in')}>
      <>
        {renderComponents(page.components.header)}
        <BreadcrumbBar
          links={[
            { label: 'Home', url: '/' },
            { label: 'My Account', url: '/account' },
            { label: 'Order History', url: '/account/order-history' },
          ]}
        />
        <MainContent>
          <OrderHistory />
        </MainContent>
        {renderComponents(page.components.footer)}
      </>
    </Page>
  )
}

export default Index

export const getStaticProps = (ctx) =>
  getOutlineRenderGraph(ctx, 'DEFAULT', 'account/order-history', {
    title: 'Order History',
    noIndex: true,
    noFollow: false,
  })
